<template>
  <div class="convert-key-widget-v2" :class="{ 'is-mobile': $store.getters.isMobile }" :style="getStyle">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <bg-style class="convert-key-widget-v2__content relative" :is-disabled="$store.getters.isStandAloneMode"
        :bg="model.background" :mobile-bg="model.mobileBackground">
        <rich-text v-if="model.titleVisible" v-model="model.title" :stroke.sync="model.titleStroke" :editing="editing"
          class="convert-key-widget-v2__title w-full" theme="snow" :disabled="!editing" />
        <im-form label-position="top">
          <div class="input-area">
            <im-input v-model.trim="code" class="convert-input" :class="{ 'is-edit': editing }"
              :placeholder="$t('siteBuild.convertInput')" :disabled="editing" />
          </div>
          <form-item class="btn-area">
            <div class="flex w-full items-center justify-center">
              <im-button class="submit-btn" :disabled="submitDisabled" :loading="loading" @click="handleSubmit">{{
                $t('siteBuild.convert') }}</im-button>
            </div>
          </form-item>
        </im-form>
      </bg-style>
    </module-block>
    <reward-info-dialog ref="confirm" :title="$t('siteBuild.convertTip2')" type="success" :data="detail" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import { isNil } from 'lodash-es'
import { colord } from 'colord'
import RewardInfoDialog from '~/components/common/RewardInfoDialog.vue'
import RichText from '~/components/richText/index.vue'
import { Form, FormItem, Input, Button } from '~/site/components/forms'
import { DeviceEnum } from '~/enums/deviceEnum'
import { getTextColor, showCustomerGroupConditionTip } from "~/utils"
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import Bus from '~/site/model/bus'
import { BusEventMap } from '~/enums/data'
export default {
  name: 'ConvertKeyWidget',
  components: {
    ModuleBlock,
    RewardInfoDialog,
    RichText,
    ImForm: Form,
    FormItem,
    ImInput: Input,
    ImButton: Button
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: DeviceEnum.MOBILE
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      code: '',
      detail: {
        gift_list: []
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo,
      projectId: (state) => state.project.projectId,
    }),
    getStyle() {
      return {
        '--convert-key-radius': this.model.radius + 'px',
        '--convert-key-backgroundColor': getTextColor(this.model.inputBackground).color,
        '--convert-key-borderColor': getTextColor(this.model.borderBackground).color,
        '--convert-key-button-backgroundColor': getTextColor(this.model.buttonBackground).color,
        '--convert-key-button-color': getTextColor(this.model.buttonTextColor).color,
        '--convert-key-input-color': getTextColor(this.model.inputTextColor).color,
        '--convert-key-shadow-color': colord(this.model.buttonTextColor.backgroundColor).alpha(0.3).toRgbString()
      }
    },
    submitDisabled() {
      return !this.code && !this.editing
    }
  },
  methods: {
    showCustomerGroupConditionTip,
    checkRight() {
      let result = true
      if (isNil(this.userInfo?.id)) {
        this.$store.commit('user/SET_LOGINSHOW', !this.editing)
        this.$store.commit('user/SET_SITE_BIND_USER', true)
        result = false
      } else if (!this.code) {
        Message.error('Please Input Code')
        result = false
      }
      return result
    },
    async handleSubmit() {
      const valid = this.checkRight()
      if (!valid) return
      const params = {
        project_id: this.projectId,
        redemption_code: this.code
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.convertKey.convert(params))
      this.loading = false
      if (!err) {
        this.detail = {
          gift_list: res.gift || []
        }
        this.$refs.confirm.init()
        this.$utils.emitRefreshProjectVip()
        Bus.$emit(BusEventMap.RefreshLottery)
      } else if (!showCustomerGroupConditionTip(this, err)) {
        Message.error(err)
      }
    }
  }
}
</script>

<style lang="less">
.convert-key-widget-v2 {
  padding: 20px 0;

  &__title {
    max-width: 1220px;
    margin: 0 auto;
    position: absolute;
    top: 10px;
    left: 0;
  }

  &__content {
    height: 350px;
    padding-top: 150px;

    .input-area {
      margin: 0 auto;
      width: 520px;
    }

    .btn-area {
      margin-top: 30px;
    }

    .convert-input {
      .site-input__inner {
        font-family: PingFangSC-Medium;
        height: 70px;
        text-align: center;
        background-color: var(--convert-key-backgroundColor);
        font-size: 20px;
        border-radius: var(--convert-key-radius);
        z-index: 10;
        position: relative;
        border: 4px solid var(--convert-key-borderColor);
        color: var(--convert-key-input-color);
        font-weight: bold;

        &::placeholder {
          color: var(--convert-key-placeholder-color);
        }
      }

      &.is-edit {
        .site-input__inner {
          border: 2px solid var(--convert-key-borderColor) !important;
        }
      }
    }

    .submit-btn {
      font-size: 20px;
      height: 46px;
      line-height: 46px;
      width: 142px;
      background-color: var(--convert-key-button-backgroundColor);
      color: var(--convert-key-button-color);
      border-radius: var(--convert-key-radius);

      &:disabled {
        background-color: var(--convert-key-button-backgroundColor);
        color: var(--convert-key-button-color);
      }
    }
  }

  &__gift {
    display: flex;
    width: 100%;
    align-items: center;
    overflow: auto;
    gap: 10px;

    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex-shrink: 0;
    }
  }

  &.is-mobile {
    padding: 10px;

    .convert-key-widget-v2__title {
      padding: 0 5px;
      top: 0;
    }

    .convert-key-widget-v2__content {
      padding-top: 62px;
      height: 180px;

      .input-area {
        width: 180px;

        .site-input__inner {
          height: 40px;
          border-width: 2px;

          &:placeholder-shown {
            font-size: 18px;
          }
        }
      }

      .btn-area {
        margin-top: 20px;

        .submit-btn {
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          width: auto;
          padding: 0 30px;
        }
      }
    }
  }
}
</style>
